import React from 'react';
import { BsTwitter, BsInstagram, BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/IsmaelRajaohar1">
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="https://www.facebook.com/zolalainaismael.rajaoharimanana">
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href="https://www.instagram.com/_zorajaoharimanana_/">
        <BsInstagram />
      </a>
    </div>
    <div>
      <a href="https://github.com/Ismael148">
        <BsGithub />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/ismael-rajaoharimanana-8330761b6/">
        <BsLinkedin />
      </a>
    </div>
  </div>
);

export default SocialMedia;
